const yieldFunction = async (callback: CallableFunction) => {
    await window.yieldToMainThread();
    callback();
};

export const initYieldFunctions = async () => {
    window.yieldToMainThread = async () => {
        if (
            'scheduler' in window &&
            typeof window.scheduler === 'object' &&
            window.scheduler !== null
        ) {
            if ('yield' in window.scheduler && typeof window.scheduler.yield === 'function') {
                await window.scheduler.yield();
                return;
            }

            if ('postTask' in window.scheduler && typeof window.scheduler.postTask === 'function') {
                // We choose user-visible since user can interact with the page during the yielding interlude.
                // eslint-disable-next-line no-empty-function
                await window.scheduler.postTask(() => {}, { priority: 'user-visible' });
                return;
            }
        }

        await new Promise(resolve => {
            setTimeout(resolve, 0);
        });
    };

    window.withYieldCallback = func => {
        return () => {
            // we don't need to `await` here, because the async function above will `await` the main thread yield
            // and then call the callback function.
            // eslint-disable-next-line no-void
            void yieldFunction(func);
        };
    };
};
